import React, { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useRouteMatch } from 'react-router-dom';

import { setPortal } from 'modules/portal';
import { showSuccessSnackbar } from 'modules/snackbar';

import MainTemplate from 'pages/templates/MainTemplate';
import MbTabs from 'components/organisms/MbTabs';

import OpenRTBMediaRtbStatistics from './OpenRTBMediaRtbStatistics';
import OffListStatistics from './OffListStatistics';
import MediaDetailPopup from './MediaDetailPopup';

const OpenRTBManageStatistics = () => {
  let { path } = useRouteMatch();
  const dispatch = useDispatch();
  const { menu, portal } = useSelector(({ menu, portal, common }) => ({
    menu: menu.list === null ? new Map() : menu.list,
    portal: portal,
  }));

  const handlePortalUrl = (url) => {
    let newPortal = portal.portal;
    let popIndex = newPortal.length;
    newPortal[popIndex] = { url: url, cnt: popIndex };
    dispatch(setPortal(newPortal));
  };

  const tabList = () => {
    for (let curMenu of menu.values()) {
      if (typeof curMenu.subMenu !== 'undefined') {
        const cur = curMenu.subMenu.get(path);
        if (typeof cur !== 'undefined') {
          // 현재 2dapth url에 매칭되는 것이 있으면 그 메뉴의 하위 tab 반환
          return cur.subMenu;
        }
      }
    }
  };

  const handleClickSnackbar = useCallback((snackbarOptions) => {
    dispatch(showSuccessSnackbar(snackbarOptions));
    //eslint-disable-next-line
  }, []);

  return (
    <MainTemplate>
      <MbTabs
        name="OpenRTBManageStatistics"
        tabMenuList={tabList()}
        tabs={{
          '/manage/openrtb/media_rtb': {
            tabComponent: (
              <OpenRTBMediaRtbStatistics
                handleClickSnackbar={handleClickSnackbar}
              />
            ),
          },
          '/manage/openrtb/off_list': {
            tabComponent: <OffListStatistics />,
            isPop: 1,
          },
          '/manage/openrtb/mediaRtbDetail': {
            tabComponent: (
              <MediaDetailPopup
                handlePortalUrl={handlePortalUrl}
                handleClickSnackbar={handleClickSnackbar}
              />
            ),
            // isPop: 1,
          },
        }}
      />
    </MainTemplate>
  );
};

export default OpenRTBManageStatistics;
